import { render } from "./ViewTerminals.vue?vue&type=template&id=1cee57fa&scoped=true"
import script from "./ViewTerminals.vue?vue&type=script&lang=js"
export * from "./ViewTerminals.vue?vue&type=script&lang=js"

import "./ViewTerminals.vue?vue&type=style&index=0&id=1cee57fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cee57fa"]])

export default __exports__